<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="同意詳細"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <v-card-text class="pa-0">
        <div class="modal-body">
          <v-container>
            <v-row>
              <v-col class="text-right">
                <div
                  class="btn-container justify-content-end"
                  v-permission.admin.normal
                  v-if="isAgreeChangeTarget"
                >
                  <v-btn
                    v-if="agreementItem.agreementStatus === null"
                    color="primary"
                    @click="hold"
                  >
                    同意保留
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="AgreeStatusChange"
                    class="ml-2"
                  >
                    同意
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="掲載開始日時"
                      :value="$filter.datetime(agreementItem.postStartDate)"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="同意タイトル"
                      :value="agreementItem.agreementTitle"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div>
                      <span>同意内容</span>
                      <div class="agreement-Text pa-1 ma-1">
                        {{ agreement.agreementText }}
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="同意者"
                      :value="
                        agreementItem.agreementStatus === 'ON_HOLD'
                          ? '-'
                          : $filter.emptyTo(agreementItem.signer, '-')
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="同意日時"
                      :value="
                        agreementItem.agreementStatus === 'ON_HOLD'
                          ? '-'
                          : $filter.datetime(agreementItem.signedDate || '', {
                              s: true,
                            })
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <app-label-group
                      label="状態"
                      :value="
                        $filter.enumTo(
                          agreementItem.agreementStatus,
                          'agreementStatusItems',
                          '未同意'
                        )
                      "
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { AgreementInfoList, AgreementDetail } from "@/apis/AgreementApi";
import { VueFinalModal } from "vue-final-modal";
import AgreeStatusChangeConfirm from "@/modals/agreement/AgreeStatusChangeConfirm.vue";

export default defineComponent({
  name: "AgreementReference",
  props: {
    agreementItem: {
      type: Object as PropType<AgreementInfoList>,
      required: true,
    },
    agreementKeyId: {
      type: String,
      required: true,
    },
    isLatest: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isLoaded: false,
      agreement: {} as AgreementDetail,
    };
  },
  computed: {
    isAgreeChangeTarget(): boolean {
      return this.isLatest && this.agreementItem.agreementStatus !== "AGREED";
    },
  },
  async mounted() {
    this.agreement = await this.$api.agreement.getAgreementDetail(
      this.agreementItem.agreementSeq
    );
    this.isLoaded = true;
  },
  methods: {
    async AgreeStatusChange() {
      await this.$modal.show(AgreeStatusChangeConfirm, {
        agreementItem: this.agreementItem,
        agreementKeyId: this.agreementKeyId,
        agreementText: this.agreement.agreementText,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    async hold() {
      await this.$confirm(
        `当内容に対する同意を「保留」とします。よろしいですか？\n保留にした場合、同意一覧から同意可能です。`
      );
      await this.$api.agreement.postAgreementHold(
        this.agreementItem.agreementSeq,
        {
          agreementKeyId: this.agreementKeyId,
        }
      );
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
  },
});
</script>

<style scoped lang="scss">
:deep(.modal-body) {
  max-height: 70vh;
  overflow-y: auto;
}
:deep(.agreement-Text) {
  max-height: 233px;
  overflow-y: scroll;
  white-space: pre-wrap;
  border: 1px solid #dee2e6;
  border-radius: 5px;
  line-height: 1.5;
}
</style>
